import React from "react";
import {FormattedMessage} from "react-intl";
import classes from "./styles.module.css";

const PsaStatuses = {
    created: 0,
    inprogess: 1,
    processed: 2,
    paymentDeclined: 3,
    error: 4,
};

function PcaFilters({onSelectFilter}) {
    return (
        <div className={classes.Card}>
            <div className={classes.Body}>
                <div className={classes.Group}>
                    <h6 className={classes.Title}>
                        <FormattedMessage id="PcaFilters.title.status" defaultMessage="Статус"/>
                    </h6>
                    <div className={classes.Column}>
                        <div className={classes.CheckboxWrap}>
                            <input id="inactive" type="checkbox"
                                   onChange={(e) => onSelectFilter({[PsaStatuses.created]: e.target.checked})}/>
                            <label htmlFor="inactive" className={classes.CustomCheckbox}>
                                <div className={classes.InProgressIcon}/>
                                <span><FormattedMessage id="PcaFilters.status.inactive"
                                                        defaultMessage="Не активен"/></span>
                            </label>
                        </div>

                        <div className={classes.CheckboxWrap}>
                            <input id="inProgress" type="checkbox"
                                   onChange={(e) => onSelectFilter({[PsaStatuses.inprogess]: e.target.checked})}/>
                            <label htmlFor="inProgress" className={classes.CustomCheckbox}>
                                <div className={classes.PendingIcon}/>
                                <span><FormattedMessage id="PcaFilters.status.inProgress"
                                                        defaultMessage="Обрабатывается"/></span>
                            </label>
                        </div>

                        <div className={classes.CheckboxWrap}>
                            <input id="processed" type="checkbox"
                                   onChange={(e) => onSelectFilter({[PsaStatuses.processed]: e.target.checked})}/>
                            <label htmlFor="processed" className={classes.CustomCheckbox}>
                                <div className={classes.ProcessedIcon}/>
                                <span><FormattedMessage id="PcaFilters.status.processed"
                                                        defaultMessage="Выплачен"/></span>
                            </label>
                        </div>

                        <div className={classes.CheckboxWrap}>
                            <input
                                id="processedWithErrors"
                                type="checkbox"
                                onChange={(e) =>
                                    onSelectFilter({
                                        [PsaStatuses.error]: e.target.checked,
                                        [PsaStatuses.paymentDeclined]: e.target.checked,
                                    })
                                }
                            />
                            <label htmlFor="processedWithErrors" className={classes.CustomCheckbox}>
                                <div className={classes.processedWithErrorsIcon}/>
                                <span><FormattedMessage id="PcaFilters.status.error"
                                                        defaultMessage="Ошибка / Платеж отклонен"/></span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PcaFilters;



// WEBPACK FOOTER //
// ./src/Components/PcaFilters/index.js